import { useField } from 'formik'
import { BrandPlanTactic } from 'types'

export const useTacticWithCount = (fieldName: string, relevantTactics?: BrandPlanTactic[]) => {
  const [tacticsField, , { setValue: setItemTactics }] = useField<BrandPlanTactic[] | undefined>(`${fieldName}.tactics`)
  const [formTacticsField, , { setValue: setFormTactics }] = useField<BrandPlanTactic[]>('tactics')
  const [, , { setValue: setCount }] = useField<number>(`${fieldName}.count`)

  // undefined means old data (no per-content tactics field); [] means new data with none selected yet
  const isOldData = tacticsField.value === undefined
  const tactics = isOldData ? formTacticsField.value ?? [] : tacticsField.value ?? []
  const setTactics = isOldData ? setFormTactics : setItemTactics

  const countableTactics = (list: BrandPlanTactic[]) =>
    relevantTactics ? list.filter((t) => relevantTactics.includes(t)) : list

  const addTactic = (tactic: BrandPlanTactic) => {
    if (countableTactics(tactics).length === 0) setCount(4)
    setTactics([...tactics, tactic])
  }

  const removeTactic = (tactic: BrandPlanTactic) => {
    const newTactics = tactics.filter((t) => t !== tactic)
    if (countableTactics(newTactics).length === 0) setCount(0)
    setTactics(newTactics)
  }

  return { tactics, addTactic, removeTactic }
}
